// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2sxvo","colBig":"styles_colBig__1KqBn","colSmall":"styles_colSmall__2GXlt"};